/** A cell Excel would run as a formula: starts with =, +, -, @, a tab or a carriage return. */
const FORMULA_START = /^[=+\-@\t\r]/;
/** Wholly a number, such as -25.00 or -5%, which cannot run and stays a number. */
const PLAIN_NUMBER = /^-?[\d,.]+%?$/;

/**
 * One CSV cell. Quoted where it holds a comma, quote or line break, and
 * prefixed with an apostrophe where a spreadsheet would otherwise execute it,
 * since the cells carry free text from I&C comments and site names.
 */
export const csvCell = (value: string): string => {
	const safe = FORMULA_START.test(value) && !PLAIN_NUMBER.test(value) ? `'${value}` : value;
	return /[",\n\r]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
};

export const buildCSVString = (headers: string[], rows: Record<string, unknown>[]): string => {
	const escape = (v: unknown) => `"${String(v ?? '').replace(/"/g, '""')}"`;
	return [
		headers.join(','),
		...rows.map((r) => headers.map((h) => escape(r[h])).join(',')),
	].join('\n');
};
